import React from 'react';
import ReactDOM from 'react-dom';
// import './styles/edb.css';

// Estilos dos alertas
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/stackslide.css';

import "react-datepicker/dist/react-datepicker.css";
import 'react-checkbox-tree/lib/react-checkbox-tree.css';

//Estilos do portal adaptativa
import './styles/adap/adap-geral.css';
import './styles/adap/adap-sidebar.css';
import './styles/adap/adap-modificadores.css';
import './styles/adap/adap-modais.css';
import './styles/adap/adap-home-cards.css';
import './styles/rc-rate.css';
import './styles/react-tags.css';
import './styles/charts-d3.css';

import App from './components/App';

import { Provider } from 'unstated'

// import 'json.date-extensions';
// overwrite for 'json.date-extensions'
import './utility/JsonDateParser';

// definição global dos formatos dos calendários
import { registerLocale, setDefaultLocale } from "react-datepicker";
import ptBR from 'date-fns/locale/pt-BR';
registerLocale('pt-BR', ptBR);
setDefaultLocale('pt-BR');

JSON.useDateParser();


ReactDOM.render(
    <Provider>
        <App />
    </Provider>,
    document.getElementById('root'));